import * as React from "react";
import { Checkbox, TableCell, TableRow } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import {
  BaseTableCell,
  KeyValue,
  Query,
  SimpleTableRow,
} from "../../interfaces";
import ModalDialog from "../ModalDialog";
import BranchOfficeDeposits from "../../containers/BranchOfficeDeposits";

interface Props {
  appState?: Query;
  tableData: SimpleTableRow[];
  totalsRow?: KeyValue;
  tableCheckbox?: KeyValue;
  app?: string;
}

const useClasses = makeStyles({
  rowOnClick: {
    "cursor": "pointer",
    "&.MuiTableRow-root.MuiTableRow-hover:focus": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
  },
  tableCell: {
    maxWidth: 200,
  },
  tableCellCheck: {
    "&.MuiTableCell-paddingCheckbox": {
      width: "fit-content",
      textAlign: "left",
    },
  },
});

export default function SimpleTableBody({
  appState,
  tableData,
  totalsRow,
  tableCheckbox,
  app,
}: Props) {
  const classes = useClasses();
  const [open, setOpen] = React.useState("");
  const [name, setName] = React.useState("");

  const showModal = (cert: string, name: string) => {
    if (cert && name && appState) {
      setOpen(cert);
      setName(name);
    }
  };

  const branchOfficeModal = appState ? (
    <ModalDialog
      title={name}
      display={open !== ""}
      setDisplay={() => setOpen("")}
      maxWidth="lg"
    >
      <BranchOfficeDeposits
        providedAppState={{
          ...appState,
          filters: { ...appState.filters, cert: open },
        }}
      />
    </ModalDialog>
  ) : (
    ""
  );
  return (
    <>
      {tableData.map((tableCell: SimpleTableRow, index: number) => {
        return (
          <TableRow
            id={`simple-table-row-${index}`}
            key={`${index}`}
            tabIndex={0}
            onKeyPress={tableCell.rowOnClick}
            onClick={tableCell.rowOnClick}
            sx={{
              "&:hover": {
                backgroundColor: "#D9E8F6",
              },
            }}
            className={tableCell.rowOnClick ? classes.rowOnClick : ""}
          >
            {Object.keys(tableCell).map((key: string, cellIndex: number) => {
              const value = (tableCell[key] as BaseTableCell).value;
              const cert = (tableCell.CERT as BaseTableCell)?.value?.toString();
              const name =
                (tableCell.NAMEFULL as BaseTableCell)?.value?.toString() ??
                (tableCell.NAME as BaseTableCell)?.value?.toString();
              const noValue = !value && app === "failures";
              const displayValue = noValue ? "0" : value;
              const isInstName = key === "NAMEFULL";
              return key !== "rowOnClick" ? (
                cellIndex === 0 && tableCheckbox ? (
                  <TableCell
                    padding="checkbox"
                    className={classes.tableCellCheck}
                    id={`${key}-${index}`}
                    key={`${key}`}
                    style={(tableCell[key] as BaseTableCell).styles}
                  >
                    <Checkbox
                      id={`table-row-check-box${index}`}
                      color="primary"
                      checked={tableCheckbox.allCheckboxes[value.toString()]}
                      value={value.toString()}
                      onChange={(e: any) => {
                        tableCheckbox.checkboxClick(e.target.value);
                      }}
                      inputProps={{
                        "aria-label": "select all desserts",
                      }}
                    />
                    {value}
                  </TableCell>
                ) : (
                  <TableCell
                    className={classes.tableCell}
                    id={`${key}-${index}`}
                    key={`${key}`}
                    style={
                      isInstName
                        ? {
                            color: "blue",
                            textDecoration: "underline",
                            fontWeight: "bold",
                            textAlign: "left",
                            cursor: "pointer",
                          }
                        : (tableCell[key] as BaseTableCell).styles
                    }
                    onClick={() => showModal(cert, name)}
                  >
                    {displayValue}
                  </TableCell>
                )
              ) : (
                undefined
              );
            })}
          </TableRow>
        );
      })}
      {totalsRow
        ? totalsRow.map((tableCell: SimpleTableRow, index: number) => {
            return (
              <TableRow
                id={`simple-table-row-${index}-total`}
                key={`${index}`}
                hover
                tabIndex={0}
              >
                {Object.keys(tableCell).map(
                  (key: string, totalIndex: number) => {
                    const value = (tableCell[key] as BaseTableCell).value;
                    const noValue =
                      !value && app === "failures" && key !== "title";
                    const displayValue = noValue ? "0" : value;
                    return totalIndex === 0 ? (
                      <TableCell
                        className={classes.tableCell}
                        id={`${key}-${totalIndex}`}
                        key={`${key}`}
                        style={{ fontWeight: "bold" }}
                      >
                        {tableCell.title ? tableCell.title.toString() : "TOTAL"}
                      </TableCell>
                    ) : (
                      <TableCell
                        className={classes.tableCell}
                        id={`${key}-${totalIndex}`}
                        key={`${key}`}
                        style={{ fontWeight: "bold" }}
                      >
                        {displayValue}
                      </TableCell>
                    );
                  },
                )}
              </TableRow>
            );
          })
        : undefined}
      {branchOfficeModal}
    </>
  );
}
